const SimplePayTerms = () => (
  <div className="flex-1">
    <h3 className="text-2xl font-bold mb-4">Adattovábbítási nyilatkozat</h3>
    <p className="my-2">
      Jelen nyilatkozat elfogadásával tudomásul veszem, hogy a{' '}
      <span className="font-bold">
        Parola Kft (1097 Budapest, Könyves Kálmán krt. 12-14. 2. emelet 2B-300)
      </span>{' '}
      adatkezelő által a{' '}
      <a
        href="https://webaruhaz.parola.hu"
        target="_blank"
        rel="noreferrer"
        className="text-lightBlue-100"
      >
        https://webaruhaz.parola.hu
      </a>{' '}
      felhasználói adatbázisában tárolt alábbi személyes adataim átadásra kerülnek a SimplePay Zrt., mint adatfeldolgozó részére. Az adatkezelő
      által továbbított adatok köre az alábbi: név, e-mail cím, számlázási cím.
    </p>
    <p className="my-2">
      Az adatfeldolgozó által végzett adatfeldolgozási tevékenység jellege és célja a
      SimplePay Adatkezelési tájékoztatóban, az alábbi linken tekinthető meg:{' '}
      <a
        href="https://simplepay.hu/adatkezelesi-tajekoztatok/"
        target="_blank"
        rel="noreferrer"
        className="text-lightBlue-100"
      >
        https://simplepay.hu/adatkezelesi-tajekoztatok/
      </a>
    </p>
  </div>
);

export default SimplePayTerms;
